import React from 'react'
import PropTypes from 'prop-types'
import { Column } from 'wrappers/FlexTable'

const BathFilter = (props) => {
  const { selected, onChange, options } = props

  const handleChange = (bath) => {
    const newSelected = selected.includes(bath)
      ? selected.filter((b) => b !== bath)
      : [...selected, bath]
    onChange(newSelected)
  }

  return (
    <Column>
      <div
        style={{
          margin: '24px 0px',
          fontWeight: '500',
          fontSize: '14px',
          lineHeight: '19px',
          color: '#fff',
        }}
      >
        Bathrooms
      </div>
      <div className="amenity-filter">
        {options.map((option) => (
          <div key={option.value} className="amenity-filter-item">
            <input
              type="checkbox"
              id={`bath-${option.value}`}
              checked={selected.includes(option.value)}
              onChange={() => handleChange(option.value)}
            />
            <label htmlFor={`bath-${option.value}`}>{option.name}</label>
          </div>
        ))}
      </div>
    </Column>
  )
}

BathFilter.propTypes = {
  selected: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ).isRequired,
}

export default BathFilter 